import api from "../axios_service.js";

export async function fetchClientes(filtros) {
  const response = await api.get(
    `/colaborador/clientes${filtros ? filtros : ""}`
  );
  return response.data.result;
}
